define(function () {
    const IpsModelCollection = require('civicsBase/ipsModelCollection');
    const utils = require('civicsUtils/general_utilities');

    return IpsModelCollection.extend({
        urlRoot: '/delegate/civics-api/api/',
        instrumentUrls: {
            building: 'cdr/applications/Building/',
            businesslicense: 'cdr/applications/businesslicense/',
            codeenforcement: 'cdr/applications/CodeEnforcement/',
            planning: 'cdr/applications/Planning/',
            project: 'cdr/applications/Project/',
            tradelicense: 'cdr/applications/TradeLicense/',
            use: 'cdr/applications/Use/',
            servicerequest: 'crm/servicerequests/'
        },
        url: function () {
            var retVal = 'ERROR';
            if (this.instrumentType &&
                (this.relationshipType.toLowerCase() == 'parents' || this.relationshipType.toLowerCase() == 'children' || this.relationshipType.toLowerCase() == 'servicerequests') &&
                this.instrumentID){
                retVal = this.urlRoot + this.instrumentUrls[this.instrumentType.toLowerCase()]+this.instrumentID+'/'+this.relationshipType+'?lightweightextensions=true';
            }
            return retVal;
        },
        parse:function(response){
            var data = response.data;
            $.each(data,function(index,el){
                el.relationshipType = this.relationshipType;
                el.newID = this.relationshipType+'|'+el.id;
                el.recordType = this.instrumentType;
                el.instrumentType = this.instrumentType;
                if(this.relationshipType.toLowerCase() == 'parents' && el.parentApplication){
                    el.linkID = el.parentApplication.id;
                    el.displayID = el.parentApplication.applicationNumber;
                    el.displayDescription = (el.parentApplication.applicationType.portalDescription) ? el.parentApplication.applicationType.portalDescription : el.parentApplication.applicationType.description
                    if(el.parentApplication.isPortalProject)
                        el.hide = true;
                } else if(el.childApplication){
                    el.linkID = el.childApplication.id;
                    el.displayID = el.childApplication.applicationNumber;
                    el.displayDescription = (el.childApplication.applicationType.portalDescription) ? el.childApplication.applicationType.portalDescription : el.childApplication.applicationType.description
                    if(el.childApplication.isPortalProject)
                        el.hide = true;
                }
            }.bind(this));
            return data;
        }
    });
});